import ConfirmationModal from "components/common/ConfirmationMessage";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

const { ListLayout } = require("components/common/ListLayout");
const { fetchInterpretersWithAppointments } = require("slices/inviteInterpreterSlice");
const { inviteInterpretersSelector } = require("slices/inviteInterpreterSlice");

const InterpretersWithAppointments = ({ itemId, showInvitedList,height }) => {
    const dispatch = useDispatch()
    const { interpretersWithAppointments, last_page: totalPages, loader } = useSelector(inviteInterpretersSelector);
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}

    });
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const fetchData = async () => {
        dispatch(fetchInterpretersWithAppointments(itemId))
    };

    React.useEffect(() => {
        fetchData();
    }, [itemId]);

    const handleAddHospitalPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }
    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
    className:"successToast",
})
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchInterpretersWithAppointments(itemId))
            hideConfirmDialog()
        }
        else {
             toast.error(message,
        {
          className:"errorToast",
        }
      );
        }
    };
    const handleRemoveItems = React.useCallback(() => {
        // dispatch(removeInterpretersWithAppointments({ ids: selectedItems }, submitCallback))
    }, [selectedItems])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(interpretersWithAppointments.map((interpretersWithAppointment) => interpretersWithAppointment.id.toString()))
    }, [selectedItems, selectAll, interpretersWithAppointments])




    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                    </div>
                </th>
                <th className="col-1">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Code</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Phone</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th>

            </tr>
        )
    }, [selectedItems, interpretersWithAppointments])

    const renderTableContent = React.useCallback(() => {
        return (
            interpretersWithAppointments?.map((item, index) => {
                return <InterpretersWithAppointmentsItem item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddHospitalPopUp} />
            })
        )
    }, [interpretersWithAppointments, selectedItems]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    return (
        <>
            <ListLayout
                heading=""
                title="Interpreters with Appointment"
                addButtonDisabled={true}
                buttonTitle="Add Hospital"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchInterpretersWithAppointments}
                selectedItems={selectedItems}
                handleRemoveItems={handleRemoveItems}
                // renderAddForm={}
                height={height}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddHospitalPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                sortConfig={sortConfig}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                loader={loader}
                showRemoveOnTop={true}
                containerStyle={{
                    marginTop: 20
                }}
                time={false}


            >


                {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
                {/* <AddHospital item={addForm.item} show={addForm.show} refAddutton={refAddutton} onClose={handleClose} /> */}
            </ListLayout>
            {/* Create full page Loader */}

        </>
    )

};

const InterpretersWithAppointmentsItem = ({
    item, index, selectedItems, handleChange, handleAddPopUp
}) => {
    const dispatch = useDispatch();

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                </div>
            </td>
            <td>
                {item?.code}
            </td>
            <td>
                {item?.first_name + " " + item?.last_name}
            </td>
            <td>
                {item?.email}
            </td>
            <td>
                {item?.phone}
            </td>
            <td>
                {item?.languages?.map(l => l?.language?.name + ", ")}
            </td>

        </tr>
    )
}


export default InterpretersWithAppointments;